import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@app/core/services/authentication/authentication.service';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationGuard {
	private router = inject(Router);
	private authenticationService = inject(AuthenticationService);

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const redirectToExternalRoute: boolean = window.location.host.includes('open'); //TODO: Check if this the correct way to check if the route is open.

		if (redirectToExternalRoute) {
			this.router.navigate(['/open']); //TODO: Use enum.
			return false;
		}

		if (this.authenticationService.token) {
			return true;
		} else {
			this.authenticationService.logout(); // TODO: maybe change the name of the logout method because at this point the user is not logged in yet.
			return false;
		}
	}
}
